import axios, {AxiosRequestConfig} from 'axios';
import env from 'react-dotenv';

const config: AxiosRequestConfig = {
  baseURL: env.API_BASE,
  timeout: 20000,
  headers: {
    'accept-language': 'ES', //Temporal
    'widget-api-authorization': env.WIDGET_API_AUTHORIZATION,
    'widget': 'wallet_widget_fihogar'
  },
};

export default axios.create(config);
